import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _class, _descriptor, _descriptor2, _dec3, _dec4, _class2, _descriptor3, _descriptor4, _descriptor5;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store, Model } from 'libx';
import map from 'lodash/map';
import fromPairs from 'lodash/fromPairs';
import { observable, action, computed } from 'mobx';
import { task } from 'mobx-task';
import { extractMessageFromError } from '../utils/errorUtil';
import { NotificationPreferencesAPI } from './API';
import env from '../misc/env';
var NotificationPreferencesStore = (_dec3 = task.resolved, _dec4 = action.bound, _class2 = /*#__PURE__*/function (_Store) {
  function NotificationPreferencesStore() {
    var _this2;
    _classCallCheck(this, NotificationPreferencesStore);
    _this2 = _callSuper(this, NotificationPreferencesStore, arguments);
    _initializerDefineProperty(_this2, "masterMedia", _descriptor3, _this2);
    _initializerDefineProperty(_this2, "typesMedia", _descriptor4, _this2);
    _initializerDefineProperty(_this2, "hasChanges", _descriptor5, _this2);
    _this2.api = new NotificationPreferencesAPI({
      baseURL: env.NOTIFICATION_API,
      getToken: function getToken() {
        return _this2.rootStore.authStore.token;
      }
    });
    return _this2;
  }
  _inherits(NotificationPreferencesStore, _Store);
  return _createClass(NotificationPreferencesStore, [{
    key: "member",
    get: function get() {
      return this.rootStore.sessionStore.member;
    }
  }, {
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.api.get({
                workspace_id: this.member.workspaceId,
                user_id: this.member.userPublicId
              }).then(this.parsePrefs));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
  }, {
    key: "save",
    value: function () {
      var _save = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var msg, prefs, newPrefs;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              msg = this.rootStore.flashMessageStore.create('Updating notification preferences...');
              _context2.prev = 1;
              prefs = this.serializePreferences();
              _context2.next = 5;
              return this.api.patch({
                workspace_id: this.member.workspaceId,
                user_id: this.member.userPublicId
              }, prefs);
            case 5:
              newPrefs = _context2.sent;
              this.member.set({
                notificationPreferences: newPrefs
              });
              this.parsePrefs(newPrefs);
              msg.done('Updated notification preferences!').autoDismiss();
              _context2.next = 14;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](1);
              msg.failed(extractMessageFromError(_context2.t0));
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 11]]);
      }));
      function save() {
        return _save.apply(this, arguments);
      }
      return save;
    }()
  }, {
    key: "parsePrefs",
    value: function parsePrefs(prefs) {
      var _this3 = this;
      this.masterMedia = new MediaContainer(_objectSpread(_objectSpread({
        key: 'media'
      }, prefs.media), {}, {
        toggleChanges: function toggleChanges() {
          return _this3.hasChanges = true;
        }
      }));
      this.typesMedia.replace(map(prefs.types_media, function (props, key) {
        return new MediaContainer(_objectSpread(_objectSpread({
          key: key
        }, props), {}, {
          toggleChanges: function toggleChanges() {
            return _this3.hasChanges = true;
          }
        }));
      }));
    }
  }, {
    key: "serializePreferences",
    value: function serializePreferences() {
      var typesMedia = fromPairs(this.typesMedia.map(function (m) {
        return [m.key, m.toJSON()];
      }));
      var media = this.masterMedia.toJSON();
      return {
        media: media,
        types_media: typesMedia
      };
    }
  }]);
}(Store), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "masterMedia", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "typesMedia", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "hasChanges", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "member", [computed], Object.getOwnPropertyDescriptor(_class2.prototype, "member"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "activate", [task], Object.getOwnPropertyDescriptor(_class2.prototype, "activate"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "save", [_dec3], Object.getOwnPropertyDescriptor(_class2.prototype, "save"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "parsePrefs", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "parsePrefs"), _class2.prototype), _class2);
export { NotificationPreferencesStore as default };
export var MediaContainer = (_dec = action.bound, _dec2 = action.bound, _class = /*#__PURE__*/function (_Model) {
  function MediaContainer(params) {
    var _this;
    _classCallCheck(this, MediaContainer);
    _this = _callSuper(this, MediaContainer, [params]);
    _initializerDefineProperty(_this, "pushEnabled", _descriptor, _this);
    _initializerDefineProperty(_this, "emailEnabled", _descriptor2, _this);
    _this.toggleChanges = params.toggleChanges;
    return _this;
  }
  _inherits(MediaContainer, _Model);
  return _createClass(MediaContainer, [{
    key: "toggleEmail",
    value: function toggleEmail(value) {
      this.toggleChanges();
      this.emailEnabled = value;
    }
  }, {
    key: "togglePush",
    value: function togglePush(value) {
      this.toggleChanges();
      this.pushEnabled = value;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        email: {
          enabled: this.emailEnabled
        },
        push: {
          enabled: this.pushEnabled
        }
      };
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "pushEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.push.enabled;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "emailEnabled", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.email.enabled;
  }
}), _applyDecoratedDescriptor(_class.prototype, "toggleEmail", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "toggleEmail"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "togglePush", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "togglePush"), _class.prototype), _class);
//# sourceMappingURL=NotificationPreferencesStore.js.map
